export const shareActivitiesDisplay = ({ trigger, timesDisplayed }) => ({
    category: 'user favoriting update',
    action: `opt-in modal ${trigger}`,
    label: timesDisplayed,
});

export const shareActivitiesUpdate = value => ({
    category: 'user favoriting update',
    action: `share favoriting ${value}`,
    label: 'favoriting dropdown',
});
